import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import GeneSearchPage from '../pages/GeneSearchPage'
import VariantSearchPage from '../pages/VariantSearchPage'
import { AboutPageWrapper } from '../pages/AboutPage'
import { PublicationsPageWrapper } from '../pages/PublicationsPage'
import { VersionHistoryWrapper } from '../pages/VersionHistoryPage'
import { HelpPageWrapper } from '../pages/HelpPage'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/' />} />
        {/* Pages */}
        <Route path='/' element={<DashboardWrapper />} />
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='about' element={<AboutPageWrapper />} />
        <Route path='help' element={<HelpPageWrapper />} />
        <Route path='publications' element={<PublicationsPageWrapper />} />
        <Route path='version-history' element={<VersionHistoryWrapper />} />
        <Route path='search-gene/:gene' element={<GeneSearchPage />} />
        <Route path='search-gene' element={<DashboardWrapper />} />
        <Route path='search-variant' element={<DashboardWrapper />} />
        <Route path='search-variant/:variant' element={<VariantSearchPage />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
